import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { BankAccountSelectorResultDto } from '../../_models/bank-account-selector-result-dto';
import { VendorAccountRawDto } from './vendor-account-raw-dto';
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { FileInfoDisplayResultDto } from '../../_models/file-info-display-result-dto';
const ɵ0 = () => VendorAccountRawDto, ɵ1 = () => KeyValueResultDto, ɵ2 = () => BankAccountSelectorResultDto, ɵ3 = () => KeyValueResultDto, ɵ4 = () => KeyValueResultDto, ɵ5 = () => FileInfoDisplayResultDto;
export class VendorAccountEditorResultDto {
    constructor() {
        this.eftInactiveReasons = [];
        this.bankAccounts = [];
        this.billingFrequencies = [];
        this.accountBillingStatuses = [];
        this.eftForms = [];
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", VendorAccountRawDto)
], VendorAccountEditorResultDto.prototype, "vendorAccount", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Array)
], VendorAccountEditorResultDto.prototype, "eftInactiveReasons", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Array)
], VendorAccountEditorResultDto.prototype, "bankAccounts", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Array)
], VendorAccountEditorResultDto.prototype, "billingFrequencies", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", Array)
], VendorAccountEditorResultDto.prototype, "accountBillingStatuses", void 0);
tslib_1.__decorate([
    Type(ɵ5),
    tslib_1.__metadata("design:type", Array)
], VendorAccountEditorResultDto.prototype, "eftForms", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5 };
